var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowthChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 1.625V18.125C2.75 18.7812 3.21875 19.25 3.875 19.25H23.375C23.9844 19.25 24.5 19.7656 24.5 20.375C24.5 21.0312 23.9844 21.5 23.375 21.5H3.875C2 21.5 0.5 20 0.5 18.125V1.625C0.5 1.01562 0.96875 0.5 1.625 0.5C2.23438 0.5 2.75 1.01562 2.75 1.625ZM15.5 6.125C15.5 5.51562 15.9688 5 16.625 5H21.8281C22.4844 5 22.9531 5.51562 22.9531 6.125V11.375C22.9531 12.0312 22.4844 12.5 21.8281 12.5C21.2188 12.5 20.7031 12.0312 20.7031 11.375V8.84375L15.5 14.0469C15.0781 14.5156 14.375 14.5156 13.9531 14.0469L10.25 10.3438L7.29688 13.2969C6.82812 13.7656 6.125 13.7656 5.70312 13.2969C5.23438 12.875 5.23438 12.1719 5.70312 11.75L9.45312 8C9.875 7.53125 10.5781 7.53125 11.0469 8L14.75 11.7031L19.1562 7.25H16.625C15.9688 7.25 15.5 6.78125 15.5 6.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthChart);
export default __webpack_public_path__ + "static/media/_growth-chart.421fba76721e6e510c1843bc5f7b9393.svg";
export { ForwardRef as ReactComponent };